(function () {
'use strict';

/**

* =========================================
* INITIALIZE PUJA PRODUCT
* =========================================
  */
  function initPujaProduct(container) {
  if (!container) return;


initHeroSlider(container);



initCountdown(container);
initSeatAvailability(container);
initPackageScroll(container);


}

/**

* =========================================
* HERO IMAGE SLIDER
* =========================================
  */
  function initHeroSlider(container) {
  const slider = container.querySelector('[data-puja-slider]');


if (!slider || slider.dataset.initialized === 'true') return;



const slides = Array.from(
  slider.querySelectorAll('.puja-hero-slide')
);

const dots = Array.from(
  slider.querySelectorAll('[data-slider-dot]')
);

const prevButton = slider.querySelector('[data-slider-prev]');
const nextButton = slider.querySelector('[data-slider-next]');

if (slides.length <= 1) return;

let currentIndex = slides.findIndex(function (slide) {
  return slide.classList.contains('is-active');
});

if (currentIndex < 0) {
  currentIndex = 0;
}

/**
 * Change active slide
 */
function goToSlide(index) {
  if (index < 0) {
    index = slides.length - 1;
  }

  if (index >= slides.length) {
    index = 0;
  }

  slides.forEach(function (slide, slideIndex) {
    slide.classList.toggle(
      'is-active',
      slideIndex === index
    );
  });

  dots.forEach(function (dot, dotIndex) {
    dot.classList.toggle(
      'is-active',
      dotIndex === index
    );
  });

  currentIndex = index;
}

/**
 * Previous button
 */
if (prevButton) {
  prevButton.addEventListener('click', function () {
    goToSlide(currentIndex - 1);
  });
}

/**
 * Next button
 */
if (nextButton) {
  nextButton.addEventListener('click', function () {
    goToSlide(currentIndex + 1);
  });
}

/**
 * Pagination dots
 */
dots.forEach(function (dot, index) {
  dot.addEventListener('click', function () {
    goToSlide(index);
  });
});

/**
 * Touch / swipe support
 */
let touchStartX = 0;
let touchEndX = 0;

slider.addEventListener(
  'touchstart',
  function (event) {
    touchStartX = event.changedTouches[0].screenX;
  },
  {
    passive: true
  }
);

slider.addEventListener(
  'touchend',
  function (event) {
    touchEndX = event.changedTouches[0].screenX;

    const difference =
      touchEndX - touchStartX;

    const swipeThreshold = 50;

    if (
      Math.abs(difference) <
      swipeThreshold
    ) {
      return;
    }

    if (difference > 0) {
      goToSlide(currentIndex - 1);
    } else {
      goToSlide(currentIndex + 1);
    }
  },
  {
    passive: true
  }
);

slider.dataset.initialized = 'true';


}

/**

* =========================================
* COUNTDOWN TIMER
* =========================================
  */
  function initCountdown(container) {
  const countdown = container.querySelector(
  '[data-puja-countdown]'
  );


if (



  !countdown ||
  countdown.dataset.initialized === 'true'
) {
  return;
}

const deadline = countdown.dataset.deadline;

if (!deadline) return;

const deadlineTime = new Date(deadline).getTime();

if (Number.isNaN(deadlineTime)) {
  return;
}

const daysElement =
  countdown.querySelector('[data-countdown-days]');

const hoursElement =
  countdown.querySelector('[data-countdown-hours]');

const minutesElement =
  countdown.querySelector('[data-countdown-minutes]');

const secondsElement =
  countdown.querySelector('[data-countdown-seconds]');

const timerElement =
  countdown.querySelector('.puja-countdown');

const expiredElement =
  countdown.querySelector('[data-countdown-expired]');


/**
 * Format number with leading zero
 */
function formatNumber(number) {
  return String(number).padStart(2, '0');
}


/**
 * Update countdown
 */
function updateCountdown() {
  const now = Date.now();

  const distance =
    deadlineTime - now;

  /**
   * Countdown expired
   */
  if (distance <= 0) {
    if (timerElement) {
      timerElement.hidden = true;
    }

    if (expiredElement) {
      expiredElement.hidden = false;
    }

    clearInterval(countdownInterval);

    return;
  }

  const days = Math.floor(
    distance / (1000 * 60 * 60 * 24)
  );

  const hours = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) /
      (1000 * 60 * 60)
  );

  const minutes = Math.floor(
    (distance % (1000 * 60 * 60)) /
      (1000 * 60)
  );

  const seconds = Math.floor(
    (distance % (1000 * 60)) /
      1000
  );

  if (daysElement) {
    daysElement.textContent =
      formatNumber(days);
  }

  if (hoursElement) {
    hoursElement.textContent =
      formatNumber(hours);
  }

  if (minutesElement) {
    minutesElement.textContent =
      formatNumber(minutes);
  }

  if (secondsElement) {
    secondsElement.textContent =
      formatNumber(seconds);
  }
}


let countdownInterval;

updateCountdown();

countdownInterval = window.setInterval(
  updateCountdown,
  1000
);

countdown.dataset.initialized = 'true';


}

/**

* =========================================
* DYNAMIC SEAT AVAILABILITY
*
* Generates a stable seat number based on:
* Product ID + Current Date
*
* The number stays the same throughout
* the day and changes automatically
* on the next day.
* =========================================
  */
  function initSeatAvailability(container) {
  const seatContainer =
  container.querySelector(
  '[data-seat-availability]'
  );


if (!seatContainer) return;



const seatElement =
  seatContainer.querySelector(
    '[data-available-seat]'
  );

if (!seatElement) return;

const min = parseInt(
  seatContainer.dataset.min,
  10
);

const max = parseInt(
  seatContainer.dataset.max,
  10
);

const productId =
  seatContainer.dataset.productId;

if (
  Number.isNaN(min) ||
  Number.isNaN(max) ||
  !productId
) {
  return;
}

/**
 * Safety check
 */
const minimum =
  Math.min(min, max);

const maximum =
  Math.max(min, max);

/**
 * Current date in YYYY-MM-DD
 */
const today =
  new Date()
    .toISOString()
    .split('T')[0];

/**
 * Create deterministic hash
 */
const value =
  String(productId) +
  '-' +
  today;

let hash = 0;

for (
  let index = 0;
  index < value.length;
  index++
) {
  hash =
    ((hash << 5) - hash) +
    value.charCodeAt(index);

  hash |= 0;
}

/**
 * Generate number between min and max
 */
const range =
  maximum - minimum + 1;

const seats =
  minimum +
  (Math.abs(hash) % range);

seatElement.textContent = seats;


}

/**

* =========================================
* SMOOTH SCROLL TO PACKAGES
* =========================================
  */
  function initPackageScroll(container) {
  const buttons =
  container.querySelectorAll(
  '[data-scroll-to-packages]'
  );


if (!buttons.length) return;



buttons.forEach(function (button) {
  button.addEventListener(
    'click',
    function (event) {
      const targetId =
        button.getAttribute('href');

      if (
        !targetId ||
        !targetId.startsWith('#')
      ) {
        return;
      }

      const target =
        document.querySelector(targetId);

      if (!target) return;

      event.preventDefault();

      const header =
        document.querySelector(
          '.header-wrapper'
        );

      const headerHeight =
        header
          ? header.offsetHeight
          : 0;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        20;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  );
});


}

/**

* =========================================
* PUJA SECTION NAVIGATION
* =========================================
  */
  function initPujaNavigation() {
  const navigation = document.querySelector(
  '[data-puja-navigation]'
  );

if (
!navigation ||
navigation.dataset.initialized === 'true'
) {
return;
}

const links = Array.from(
navigation.querySelectorAll(
'[data-puja-nav-link]'
)
);

if (!links.length) return;

/**

* Get sticky navigation height
  */
  function getNavigationOffset() {
  return navigation.offsetHeight + 20;
  }

/**

* Smooth scroll
  */
  links.forEach(function (link) {
  link.addEventListener(
  'click',
  function (event) {
  const targetId =
  link.getAttribute('href');

  if (
  !targetId ||
  !targetId.startsWith('#')
  ) {
  return;
  }

  const target =
  document.querySelector(targetId);

  if (!target) return;

  event.preventDefault();

  const header =
  document.querySelector(
  '.header-wrapper'
  );

  const headerHeight =
  header
  ? header.offsetHeight
  : 0;

  const position =
  target.getBoundingClientRect().top +
  window.scrollY -
  headerHeight -
  getNavigationOffset();

  window.scrollTo({
  top: position,
  behavior: 'smooth'
  });
  }
  );
  });

/**

* Active navigation item
  */
  const sections = links
  .map(function (link) {
  const targetId =
  link.getAttribute('href');

  if (!targetId) return null;

  const target =
  document.querySelector(targetId);

  if (!target) return null;

  return {
  link: link,
  target: target
  };
  })
  .filter(Boolean);

if (!sections.length) return;

/**

* Update active item
  */
  function updateActiveNavigation() {
  const scrollPosition =
  window.scrollY +
  getNavigationOffset() +
  80;


let activeItem =



  sections[0];

sections.forEach(function (item) {
  if (
    item.target.offsetTop <=
    scrollPosition
  ) {
    activeItem = item;
  }
});

links.forEach(function (link) {
  link.classList.remove(
    'is-active'
  );
});

activeItem.link.classList.add(
  'is-active'
);


/**
 * On mobile, keep active link visible
 */
if (window.innerWidth <= 989) {
  const navScroll =
    navigation.querySelector(
      '[data-navigation-scroll]'
    );

  if (navScroll) {
    const linkLeft =
      activeItem.link.offsetLeft;

    const linkWidth =
      activeItem.link.offsetWidth;

    const scrollLeft =
      linkLeft -
      (navScroll.clientWidth / 2) +
      (linkWidth / 2);

    navScroll.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }
}


}

let ticking = false;

window.addEventListener(
'scroll',
function () {
if (!ticking) {
window.requestAnimationFrame(
function () {
updateActiveNavigation();


        ticking = false;
      }
    );

    ticking = true;
  }
},
{
  passive: true
}


);

updateActiveNavigation();

navigation.dataset.initialized = 'true';
}

/**
 * =========================================
 * PUJA OVERVIEW - READ MORE
 * =========================================
 */
function initPujaOverview() {
  const overviewSections = document.querySelectorAll(
    '[data-puja-overview]'
  );

  overviewSections.forEach(function (overview) {
    if (overview.dataset.initialized === 'true') {
      return;
    }

    const content = overview.querySelector(
      '[data-overview-content]'
    );

    const button = overview.querySelector(
      '[data-read-more-button]'
    );

    const text = overview.querySelector(
      '[data-read-more-text]'
    );

    if (!content || !button || !text) {
      overview.dataset.initialized = 'true';
      return;
    }

    const sectionId = overview
      .closest('.shopify-section')
      ?.id;

    /*
     * Get Read More / Read Less text
     * from Shopify section settings.
     */
    const readMoreText = button.textContent.trim();

    /*
     * The Read Less text is stored as
     * a data attribute below.
     */
    const readLessText =
      button.dataset.readLess || 'Read Less';

    button.addEventListener('click', function () {
      const isExpanded =
        content.classList.contains('is-expanded');

      content.classList.toggle(
        'is-expanded',
        !isExpanded
      );

      button.classList.toggle(
        'is-expanded',
        !isExpanded
      );

      button.setAttribute(
        'aria-expanded',
        String(!isExpanded)
      );

      text.textContent = !isExpanded
        ? readLessText
        : readMoreText;
    });

    overview.dataset.initialized = 'true';
  });
}


/**
 * =========================================
 * PUJA PACKAGE SELECTION
 * =========================================
 */
function initPujaPackages() {
  const packageSections = document.querySelectorAll(
    '[data-puja-packages]'
  );

  packageSections.forEach(function (section) {

    if (section.dataset.initialized === 'true') {
      return;
    }

    const cards = Array.from(
      section.querySelectorAll(
        '[data-puja-package]'
      )
    );

    const variantInput = section.querySelector(
      '[data-selected-puja-variant]'
    );

    const continueButton = section.querySelector(
      '[data-puja-package-continue]'
    );

    if (!cards.length || !variantInput) {
      return;
    }


    function selectPackage(card) {

      const isAvailable =
        card.dataset.variantAvailable === 'true';

      if (!isAvailable) {
        return;
      }

      const variantId =
        card.dataset.variantId;

      cards.forEach(function (item) {

        item.classList.remove(
          'is-selected'
        );

        const radio = item.querySelector(
          '[data-puja-variant-radio]'
        );

        if (radio) {
          radio.checked = false;
        }

      });


      card.classList.add(
        'is-selected'
      );


      const selectedRadio =
        card.querySelector(
          '[data-puja-variant-radio]'
        );

      if (selectedRadio) {
        selectedRadio.checked = true;
      }


      variantInput.value = variantId;


      /**
       * Global event.
       * Sankalp popup and booking bar
       * can listen to this.
       */
      document.dispatchEvent(
        new CustomEvent(
          'puja:variant:change',
          {
            detail: {
              variantId: variantId,
              variantTitle: card.dataset.variantTitle,
              variantPrice: card.dataset.variantPrice,
              variantPriceFormatted:
                card.dataset.variantPriceFormatted,
              devoteeCount:
                parseInt(
                  card.dataset.devoteeCount,
                  10
                ) || 1,
              sectionId:
                section.dataset.sectionId
            }
          }
        )
      );

    }


    cards.forEach(function (card) {

      card.addEventListener(
        'click',
        function () {
          selectPackage(card);
        }
      );

    });


    if (continueButton) {

      continueButton.addEventListener(
        'click',
        function () {

          const selectedVariantId =
            variantInput.value;

          if (!selectedVariantId) {
            return;
          }


          /**
           * This event will open
           * the Sankalp Popup later.
           */
          const selectedCard =
            section.querySelector(
              '[data-puja-package].is-selected'
            );

          document.dispatchEvent(
            new CustomEvent(
              'puja:booking:start',
              {
                detail: {
                  variantId:
                    selectedVariantId,

                  variantTitle:
                    selectedCard
                      ? selectedCard.dataset.variantTitle
                      : '',

                  variantPrice:
                    selectedCard
                      ? selectedCard.dataset.variantPrice
                      : '',

                  variantPriceFormatted:
                    selectedCard
                      ? selectedCard.dataset.variantPriceFormatted
                      : '',

                  devoteeCount:
                    selectedCard
                      ? (
                          parseInt(
                            selectedCard.dataset.devoteeCount,
                            10
                          ) || 1
                        )
                      : 1,

                  sectionId:
                    section.dataset.sectionId
                }
              }
            )
          );

        }
      );

    }


    section.dataset.initialized = 'true';

  });
}


/**
 * =========================================
 * PUJA GALLERY
 * =========================================
 */
function initPujaGallery() {
  const galleries = document.querySelectorAll(
    '[data-puja-gallery]'
  );

  galleries.forEach(function (gallery) {

    if (gallery.dataset.initialized === 'true') {
      return;
    }

    const track = gallery.querySelector(
      '[data-puja-gallery-track]'
    );

    const cards = Array.from(
      gallery.querySelectorAll(
        '.puja-gallery-card'
      )
    );

    const previousButton = gallery.querySelector(
      '[data-gallery-prev]'
    );

    const nextButton = gallery.querySelector(
      '[data-gallery-next]'
    );

    const dots = Array.from(
      gallery.querySelectorAll(
        '[data-gallery-dot]'
      )
    );

    let currentIndex = 0;


    function getVisibleCards() {
      if (window.innerWidth <= 749) {
        return 1;
      }

      if (window.innerWidth <= 989) {
        return 2;
      }

      return 3;
    }


    function updateSlider() {

      if (!track || !cards.length) {
        return;
      }

      const visibleCards =
        getVisibleCards();

      const maxIndex = Math.max(
        0,
        cards.length - visibleCards
      );

      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      if (window.innerWidth <= 749) {
        return;
      }

      const cardWidth =
        cards[0].getBoundingClientRect().width;

      const gap = 24;

      const position =
        currentIndex *
        (cardWidth + gap);

      track.style.transform =
        'translateX(-' +
        position +
        'px)';


      dots.forEach(function (
        dot,
        index
      ) {
        dot.classList.toggle(
          'is-active',
          index === currentIndex
        );
      });

    }


    if (previousButton) {

      previousButton.addEventListener(
        'click',
        function () {

          currentIndex =
            Math.max(
              0,
              currentIndex - 1
            );

          updateSlider();

        }
      );

    }


    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function () {

          const maxIndex = Math.max(
            0,
            cards.length -
            getVisibleCards()
          );

          currentIndex =
            Math.min(
              maxIndex,
              currentIndex + 1
            );

          updateSlider();

        }
      );

    }


    dots.forEach(function (
      dot,
      index
    ) {

      dot.addEventListener(
        'click',
        function () {

          currentIndex = index;

          updateSlider();

        }
      );

    });


    window.addEventListener(
      'resize',
      updateSlider
    );


    /**
     * VIDEO POPUP
     */
    const modal = gallery.querySelector(
      '[data-puja-video-modal]'
    );

    const player = gallery.querySelector(
      '[data-puja-video-player]'
    );

    const triggers = gallery.querySelectorAll(
      '[data-puja-video-trigger]'
    );

    const closeButtons = gallery.querySelectorAll(
      '[data-puja-video-close]'
    );


    function getYouTubeEmbed(url) {

      let videoId = '';

      try {

        const parsedUrl =
          new URL(url);

        if (
          parsedUrl.hostname.includes(
            'youtu.be'
          )
        ) {
          videoId =
            parsedUrl.pathname
              .replace('/', '');
        } else {
          videoId =
            parsedUrl.searchParams.get(
              'v'
            );
        }

      } catch (error) {
        return '';
      }

      if (!videoId) {
        return '';
      }

      return (
        'https://www.youtube.com/embed/' +
        videoId +
        '?autoplay=1'
      );

    }


    function getVimeoEmbed(url) {

      try {

        const parsedUrl =
          new URL(url);

        const parts =
          parsedUrl.pathname
            .split('/')
            .filter(Boolean);

        const videoId =
          parts.pop();

        if (!videoId) {
          return '';
        }

        return (
          'https://player.vimeo.com/video/' +
          videoId +
          '?autoplay=1'
        );

      } catch (error) {
        return '';
      }

    }


    function openVideo(trigger) {

      if (!modal || !player) {
        return;
      }

      const type =
        trigger.dataset.videoType;

      const externalUrl =
        trigger.dataset.videoUrl;

      const shopifyVideoId =
        trigger.dataset.videoId;


      player.innerHTML = '';


      if (
        type === 'external' &&
        externalUrl
      ) {

        let embedUrl = '';

        if (
          externalUrl.includes(
            'youtube'
          ) ||
          externalUrl.includes(
            'youtu.be'
          )
        ) {

          embedUrl =
            getYouTubeEmbed(
              externalUrl
            );

        } else if (
          externalUrl.includes(
            'vimeo'
          )
        ) {

          embedUrl =
            getVimeoEmbed(
              externalUrl
            );

        }


        if (embedUrl) {

          const iframe =
            document.createElement(
              'iframe'
            );

          iframe.src = embedUrl;

          iframe.allow =
            'autoplay; fullscreen; picture-in-picture';

          iframe.allowFullscreen = true;

          player.appendChild(
            iframe
          );

        }

      }


      /*
       * Shopify video:
       *
       * We locate the original video
       * element rendered invisibly below.
       */
      if (
        type === 'shopify' &&
        shopifyVideoId
      ) {

        const sourceVideo =
          gallery.querySelector(
            '[data-shopify-video="' +
            shopifyVideoId +
            '"]'
          );

        if (sourceVideo) {

          const clone =
            sourceVideo.cloneNode(true);

          clone.controls = true;
          clone.autoplay = true;

          player.appendChild(
            clone
          );

        }

      }


      modal.hidden = false;

      document.body.style.overflow =
        'hidden';

    }


    function closeVideo() {

      if (!modal || !player) {
        return;
      }

      modal.hidden = true;

      player.innerHTML = '';

      document.body.style.overflow =
        '';

    }


    triggers.forEach(function (
      trigger
    ) {

      trigger.addEventListener(
        'click',
        function () {
          openVideo(trigger);
        }
      );

    });


    closeButtons.forEach(function (
      button
    ) {

      button.addEventListener(
        'click',
        closeVideo
      );

    });


    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          !modal.hidden
        ) {
          closeVideo();
        }

      }
    );


    updateSlider();

    gallery.dataset.initialized = 'true';

  });
}

/**
 * =========================================
 * PUJA REVIEWS SLIDER
 * =========================================
 */
function initPujaReviews() {

  const sliders = document.querySelectorAll(
    '[data-puja-reviews-slider]'
  );

  sliders.forEach(function (slider) {

    if (slider.dataset.initialized === 'true') {
      return;
    }


    const track = slider.querySelector(
      '[data-puja-reviews-track]'
    );

    if (!track) {
      return;
    }


    const cards = Array.from(
      track.querySelectorAll('.puja-review-card')
    );

    if (cards.length <= 1) {
      slider.dataset.initialized = 'true';
      return;
    }


    let currentIndex = 0;

    let slidesPerView = getSlidesPerView();

    let autoPlayInterval = null;

    let touchStartX = 0;

    let touchEndX = 0;


    /**
     * Get responsive slides count
     */
    function getSlidesPerView() {

      if (window.innerWidth <= 749) {
        return 1;
      }

      if (window.innerWidth <= 989) {
        return 2;
      }

      return 3;

    }


    /**
     * Maximum slide index
     */
    function getMaxIndex() {

      return Math.max(
        0,
        cards.length - slidesPerView
      );

    }


    /**
     * Update slider position
     */
    function updateSlider() {

      if (window.innerWidth <= 749) {
        track.style.transform = '';
        return;
      }

      const cardWidth = cards[0].offsetWidth;

      const trackStyle =
        window.getComputedStyle(track);

      const gap =
        parseFloat(trackStyle.gap) || 0;

      const moveAmount =
        currentIndex *
        (cardWidth + gap);

      track.style.transform =
        'translateX(-' +
        moveAmount +
        'px)';
    }


    /**
     * Move to next slide
     */
    function nextSlide() {

      const maxIndex =
        getMaxIndex();

      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }

      updateSlider();

    }


    /**
     * Move to previous slide
     */
    function previousSlide() {

      const maxIndex =
        getMaxIndex();

      if (currentIndex <= 0) {
        currentIndex = maxIndex;
      } else {
        currentIndex--;
      }

      updateSlider();

    }


    /**
     * Auto play
     */
    function startAutoPlay() {

      if (window.innerWidth <= 749) {
        return;
      }
      
      if (autoPlayInterval) {
        return;
      }

      autoPlayInterval = setInterval(
        nextSlide,
        5000
      );

    }


    /**
     * Stop auto play
     */
    function stopAutoPlay() {

      if (!autoPlayInterval) {
        return;
      }

      clearInterval(autoPlayInterval);

      autoPlayInterval = null;

    }


    /**
     * Pause slider on hover
     */
    slider.addEventListener(
      'mouseenter',
      stopAutoPlay
    );

    slider.addEventListener(
      'mouseleave',
      startAutoPlay
    );


    /**
     * Touch / Swipe support
     */
    slider.addEventListener(
      'touchstart',
      function (event) {

        touchStartX =
          event.changedTouches[0].screenX;

        stopAutoPlay();

      },
      {
        passive: true
      }
    );


    slider.addEventListener(
      'touchend',
      function (event) {

        touchEndX =
          event.changedTouches[0].screenX;

        const difference =
          touchStartX - touchEndX;


        if (Math.abs(difference) > 50) {

          if (difference > 0) {
            nextSlide();
          } else {
            previousSlide();
          }

        }

        startAutoPlay();

      },
      {
        passive: true
      }
    );


    /**
     * Responsive resize handling
     */
    let resizeTimeout;

    window.addEventListener(
      'resize',
      function () {

        clearTimeout(resizeTimeout);

        resizeTimeout =
          setTimeout(
            function () {

              slidesPerView =
                getSlidesPerView();

              const maxIndex =
                getMaxIndex();

              if (currentIndex > maxIndex) {
                currentIndex = maxIndex;
              }

              updateSlider();

            },
            150
          );

      }
    );


    /**
     * Initial setup
     */
    updateSlider();

    startAutoPlay();

    slider.dataset.initialized = 'true';

  });

}

/**
 * =========================================
 * PUJA FAQ
 * =========================================
 */
function initPujaFaq() {

  const faqSections =
    document.querySelectorAll(
      '[data-puja-faq]'
    );

  faqSections.forEach(function (section) {

    if (section.dataset.initialized === 'true') {
      return;
    }

    const items =
      section.querySelectorAll(
        '.puja-faq-item'
      );


    items.forEach(function (item) {

      const question =
        item.querySelector(
          '[data-puja-faq-question]'
        );


      if (!question) {
        return;
      }


      question.addEventListener(
        'click',
        function () {

          const isOpen =
            item.classList.contains(
              'is-open'
            );


          /*
           * Close all other FAQ items
           */
          items.forEach(function (
            otherItem
          ) {

            otherItem.classList.remove(
              'is-open'
            );

            const otherQuestion =
              otherItem.querySelector(
                '[data-puja-faq-question]'
              );

            if (otherQuestion) {
              otherQuestion.setAttribute(
                'aria-expanded',
                'false'
              );
            }

          });


          /*
           * Open clicked item
           * unless it was already open
           */
          if (!isOpen) {

            item.classList.add(
              'is-open'
            );

            question.setAttribute(
              'aria-expanded',
              'true'
            );

          }

        }
      );

    });


    section.dataset.initialized = 'true';

  });

}

/**
 * =========================================
 * PUJA MOBILE BOOKING BAR
 * =========================================
 */
function initPujaMobileBookingBar() {
  const bookingBars = document.querySelectorAll(
    '[data-puja-mobile-booking-bar]'
  );

  bookingBars.forEach(function (bar) {

    if (bar.dataset.initialized === 'true') {
      return;
    }

    const packageTitle = bar.querySelector(
      '[data-puja-mobile-variant-title]'
    );

    const packagePrice = bar.querySelector(
      '[data-puja-mobile-variant-price]'
    );

    const bookingButton = bar.querySelector(
      '[data-puja-mobile-booking-button]'
    );

    const buttonText = bar.querySelector(
      '[data-puja-mobile-button-text]'
    );

    if (!bookingButton) {
      return;
    }


    /**
     * Get currently selected package input.
     */
    const selectedVariantInput = document.querySelector(
      '[data-selected-puja-variant]'
    );

    let selectedVariantId = selectedVariantInput
      ? selectedVariantInput.value
      : null;


    /**
     * Update the mobile bar.
     */
    function updateMobileBookingBar(variantId) {

      if (!variantId) {
        return;
      }

      const packageCard = document.querySelector(
        '[data-puja-package][data-variant-id="' +
        variantId +
        '"]'
      );

      if (!packageCard) {
        return;
      }

      selectedVariantId = variantId;

      const isAvailable =
        packageCard.dataset.variantAvailable === 'true';

      const variantTitle =
        packageCard.dataset.variantTitle || '';

      const variantPriceFormatted =
        packageCard.dataset.variantPriceFormatted || '';


      if (packageTitle) {
        packageTitle.textContent = variantTitle;
      }

      if (packagePrice) {
        packagePrice.textContent =
          variantPriceFormatted;
      }


      bookingButton.disabled = !isAvailable;

      if (buttonText) {
        buttonText.textContent = isAvailable
          ? 'Participate Now'
          : 'Sold Out';
      }

    }


    /**
     * Sync with package selection.
     */
    document.addEventListener(
      'puja:variant:change',
      function (event) {

        if (
          !event.detail ||
          !event.detail.variantId
        ) {
          return;
        }

        updateMobileBookingBar(
          String(event.detail.variantId)
        );

      }
    );


    /**
     * Mobile booking button.
     */
    bookingButton.addEventListener(
      'click',
      function () {

        if (
          !selectedVariantId ||
          bookingButton.disabled
        ) {
          return;
        }


        const packageCard = document.querySelector(
          '[data-puja-package][data-variant-id="' +
          selectedVariantId +
          '"]'
        );

        if (!packageCard) {
          console.error(
            'Selected Puja package was not found.'
          );

          return;
        }


        /**
         * Send the SAME data structure
         * expected by puja-sankalp.js.
         */
        document.dispatchEvent(
          new CustomEvent(
            'puja:booking:start',
            {
              detail: {
                variantId:
                  packageCard.dataset.variantId,

                variantTitle:
                  packageCard.dataset.variantTitle,

                variantPrice:
                  packageCard.dataset.variantPrice,

                variantPriceFormatted:
                  packageCard.dataset
                    .variantPriceFormatted,

                devoteeCount:
                  packageCard.dataset.devoteeCount,

                sectionId:
                  packageCard
                    .closest('[data-puja-packages]')
                    ?.dataset.sectionId || '',

                source:
                  'mobile-booking-bar'
              }
            }
          )
        );

      }
    );


    /**
     * Sync initial variant.
     */
    if (selectedVariantId) {
      updateMobileBookingBar(
        selectedVariantId
      );
    }


    bar.dataset.initialized = 'true';

  });
}

/**
* =========================================
* INITIAL PAGE LOAD
* =========================================
  */
  function initAllPujaProducts() {
  const sections =
  document.querySelectorAll(
  '.puja-product-hero'
  );


sections.forEach(function (section) {
  initPujaProduct(section);
});

initPujaNavigation();
initPujaOverview();
initPujaPackages();
initPujaGallery();
initPujaReviews();
initPujaFaq();
initPujaMobileBookingBar();

}

/**

* Shopify theme editor / normal load
  */
  if (
  document.readyState === 'loading'
  ) {
  document.addEventListener(
  'DOMContentLoaded',
  initAllPujaProducts
  );
  } else {
  initAllPujaProducts();
  }

/**

* =========================================
* SHOPIFY THEME EDITOR SUPPORT
* =========================================
  */
document.addEventListener(
  'shopify:section:load',
  function (event) {

    /* =========================================
       HERO SECTION
    ========================================= */

    const heroSection =
      event.target.querySelector(
        '.puja-product-hero'
      );

    if (heroSection) {
      initPujaProduct(heroSection);
    }


    /* =========================================
       NAVIGATION SECTION
    ========================================= */

    const navigationSection =
      event.target.querySelector(
        '[data-puja-navigation]'
      );

    if (navigationSection) {
      navigationSection.dataset.initialized = '';

      initPujaNavigation();
    }


    /* =========================================
       OVERVIEW SECTION
    ========================================= */

    const overviewSection =
      event.target.querySelector(
        '[data-puja-overview]'
      );

    if (overviewSection) {
      overviewSection.dataset.initialized = '';

      initPujaOverview();
    }

    /* =========================================
       PACKAGE SECTION
    ========================================= */

    const packageSection =
    event.target.querySelector(
        '[data-puja-packages]'
    );

    if (packageSection) {
    packageSection.dataset.initialized = '';

    initPujaPackages();
    }

    /* =========================================
       GALLARY SECTION
    ========================================= */

    const gallerySection =
    event.target.querySelector(
      '[data-puja-gallery]'
    );

    if (gallerySection) {
      gallerySection.dataset.initialized = '';

      initPujaGallery();
    }

    /* =========================================
       FAQ SECTION
    ========================================= */

    const faqSection =
    event.target.querySelector(
      '[data-puja-faq]'
    );

    if (faqSection) {
      faqSection.dataset.initialized = '';

      initPujaFaq();
    }

  }
);

})();
